import { navigate } from "gatsby";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faXTwitter, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

//css
import * as styles from "../../include/css/css-components/footer/Footer.module.css";
import FetchImage from "./fetchImage";
class Footer extends Component {
  state = {};
  render() {
    return (
      <footer id={styles["footer"]}>
        <div className={styles["footerUpper"]}>
          <div className={`container-fluid`}>
            <div className={`row`}>
              <div className="col-lg-4">
                <div className={styles["footerUpperLeft"]}>
                  <a href="javascript:void(0)" className={styles["footerLogo"]}>
                    <FetchImage image="footer-logo.png" />
                  </a>
                  <address>
                    440 Louisiana Street <br />
                    Suite 550, Houston, TX 77002
                  </address>
                  <ul class={`${styles.socialLinks} d-lg-flex align-items-lg-center d-none`}>
                    <li>
                      <a href="https://twitter.com/SalvexGroup" target="_blank">
                        <FontAwesomeIcon icon={faXTwitter}></FontAwesomeIcon>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/SalvexGroup/" target="_blank">
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/salvexgroup/" target="_blank">
                        <FontAwesomeIcon icon={faLinkedinIn}></FontAwesomeIcon>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8">
                <div className={`${styles.footerUpperRight} d-flex flex-wrap`}>
                  <div class={`${styles.footerBox} d-flex flex-column`}>
                    <h4>ABOUT SALVEX</h4>
                    <ul>
                      <li>
                        <a href="https://www.aboutsalvex.com/company/" target="_blank">
                          Company
                        </a>
                      </li>
                      <li>
                        <a href="https://www.aboutsalvex.com/impact/" target="_blank">
                          Impact
                        </a>
                      </li>
                      <li>
                        <a href="https://www.aboutsalvex.com/industries/" target="_blank">
                          Industries
                        </a>
                      </li>
                      <li>
                        <a href="https://www.aboutsalvex.com/careers/" target="_blank">
                          Careers
                        </a>
                      </li>
                      <li>
                        <a href="https://www.aboutsalvex.com/case-studies/" target="_blank">
                          Case Studies
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class={`${styles.footerBox} d-flex flex-column`}>
                    <h4>CONTACT US</h4>
                    <ul>
                      <li>
                        <span>P :</span>
                        <a href="tel:7132299000">713.229.9000</a>
                      </li>
                      <li>
                        <span>F :</span> 973.556.1328
                      </li>
                      <li>
                        <span>E :</span>
                        <a href="mailto:sales@salvex.com">sales@salvex.com</a>
                      </li>
                    </ul>

                    <div class={`${styles.mobSocialBox} d-block d-lg-none`}>
                      <ul
                        class={` ${styles.socialLinks} ${styles.footerSocialLinksContainer} d-flex align-items-center`}
                      >
                        <li>
                          <a href="https://twitter.com/SalvexGroup" target="_blank">
                            <FontAwesomeIcon icon={faXTwitter}></FontAwesomeIcon>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.facebook.com/SalvexGroup/" target="_blank">
                            <FontAwesomeIcon icon={faFacebookF} />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/salvexgroup/" target="_blank">
                            <FontAwesomeIcon icon={faLinkedinIn}></FontAwesomeIcon>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class={`customized-footer footer-lower ${styles.footerLower}`}>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12 d-lg-flex align-items-lg-center justify-content-lg-center">
                {" "}
                <ul class={`${styles.footerNavList} d-flex align-items-center`}>
                  <li>
                    <a href="/terms-and-conditions">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/accessibility">Accessibility</a>
                  </li>
                </ul>
                <div class={`${styles.copyrightBox} mob-copyright-box`}>
                  <span>&copy;</span>&nbsp;{new Date().getFullYear()} <a>Salvex Group</a>, Inc.
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
